import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface DragHandleProps {
  className?: string;
  children: ReactNode;
}

export const DragHandle: FC<DragHandleProps> = ({ children, className }) => {
  return (
    <div
      className={twMerge("cursor-move", className)}
      draggable
      data-drag-handle="true"
    >
      {children}
    </div>
  );
};
